import type { BarChartMetrics, ChartRange } from '$lib/models'
import * as m from '$lib/paraglide/messages'

export const LINE_CHART_RANGES: {
	label: string
	value: ChartRange
}[] = [
	{
		label: '1D',
		value: 'day',
	},
	{
		label: '7D',
		value: 'week',
	},
	{
		label: '30D',
		value: 'month',
	},
	{
		label: '90D',
		value: 'quarter',
	},
]

export const LINE_CHART_RANGES_LIST = <ChartRange[]>['day', 'week', 'month', 'quarter']

export const BAR_CHART_METRICS: {
	label: string
	isNew?: boolean
	value: BarChartMetrics
}[] = [
	{
		label: m.metric_tps_name(),
		value: 'tps',
	},
	{
		label: m.metric_max_tps_hundred_blocks_name(),
		value: 'maxTps',
	},
	{
		label: m.metric_max_tps_one_block_name(),
		value: 'maxTpsOneBlock',
	},
	{
		label: m.metric_theor_tps_name(),
		value: 'theorTps',
	},
	{
		label: m.metric_total_txns_name(),
		value: 'txns',
		isNew: true,
	},
]
